export default __webpack_public_path__ + "static/media/1301128b3dcdac94b5c074a945ace6da.svg";